function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#EF8432",
  d: "M11.889 12c0-.389.333-.667.722-.667.389 0 .722.278.722.667v1.222c0 1.5-1.277 2.778-2.777 2.778H2.778A2.786 2.786 0 010 13.222V12c0-.389.333-.667.722-.667.39 0 .667.278.667.667v1.222c0 .722.611 1.334 1.389 1.334h7.778c.722 0 1.333-.612 1.333-1.334V12zM1.944 8.278a.706.706 0 010-1 .704.704 0 011 0l3 3V.722c0-.389.334-.722.723-.722.389 0 .666.333.666.722v9.556l3-3a.704.704 0 011 0 .704.704 0 010 1l-4.166 4.166a.704.704 0 01-1 0L1.944 8.278z"
})));